import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PlacementContext = createContext(void 0);
const PlacementProvider = ({
  children,
  placement = "page"
}) => /* @__PURE__ */ jsx(PlacementContext.Provider, { value: placement, children });
function usePlacement() {
  const context = useContext(PlacementContext);
  if (context === void 0) {
    return "page";
  }
  return context;
}
export {
  PlacementProvider,
  usePlacement
};
